<template>
  <div class="item container">
    <BananaButton to="/" variant="ghost" size="sm" class="item__back">← Toutes les blagues</BananaButton>

    <div v-if="loading" class="item__state"><span class="spin">🍌</span> On épluche…</div>

    <div v-else-if="joke" class="item__wrap reveal">
      <JokeCard :joke="joke" />

      <div class="item__toolbar">
        <BananaButton variant="danger" size="sm" @click="showReport = true">🚩 Signaler cette blague</BananaButton>
      </div>

      <CommentSection :joke-id="jokeIdNum" />

      <div class="item__more">
        <BananaButton to="/aleatoire" variant="dark">🎲 Une autre au hasard</BananaButton>
      </div>
    </div>

    <div v-else class="item__notfound reveal">
      <div class="item__peel">🍌💨</div>
      <h1>Blague introuvable</h1>
      <p>Cette perle a glissé sur une peau de banane. Elle n'existe pas (ou plus).</p>
      <BananaButton to="/" size="lg">Retour à l'accueil</BananaButton>
    </div>

    <ReportDialog
      v-if="showReport && joke"
      target="joke"
      :target-id="jokeIdNum"
      @close="showReport = false"
    />
  </div>
</template>

<script>
import JokeCard from '@/components/JokeCard.vue'
import BananaButton from '@/components/ui/BananaButton.vue'
import CommentSection from '@/components/CommentSection.vue'
import ReportDialog from '@/components/ReportDialog.vue'
import gql from 'graphql-tag'
import { JOKE_FIELDS } from '@/graphql/jokes'

export default {
  name: 'ItemPage',
  components: { JokeCard, BananaButton, CommentSection, ReportDialog },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return { joke: null, loading: true, showReport: false }
  },
  computed: {
    jokeIdNum() {
      return parseInt(this.id, 10)
    },
  },
  apollo: {
    joke: {
      query: gql`
        query GetJoke($id: Int) {
          joke(id: $id) { ...JokeFields }
        }
        ${JOKE_FIELDS}
      `,
      variables() {
        return { id: this.jokeIdNum }
      },
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (data && data.joke) this.joke = data.joke
        this.loading = loading
      },
      error(err) {
        console.error('Error fetching joke:', err)
        this.loading = false
      },
    },
  },
}
</script>

<style scoped>
.item { padding: 30px 20px 60px; }
.item__back { margin-bottom: 20px; }
.item__wrap { display: flex; flex-direction: column; gap: 24px; }
.item__toolbar { display: flex; gap: 10px; flex-wrap: wrap; }
.item__more { text-align: center; }

.item__state { text-align: center; padding: 60px; color: var(--text-soft); font-family: var(--font-accent); font-style: italic; font-size: 1.1rem; }
.spin { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.item__notfound { text-align: center; padding: 50px 20px; }
.item__peel { font-size: 4rem; margin-bottom: 12px; }
.item__notfound h1 { font-size: clamp(1.8rem, 5vw, 2.6rem); }
.item__notfound p { color: var(--text-soft); max-width: 440px; margin: 0 auto 26px; font-size: 1.05rem; }

@media (max-width: 560px) {
  .item { padding: 24px 20px 50px; }
  .item__state { padding: 44px 20px; }
}
</style>
